import { TipoGenericoRimovibile } from './tipo-generico-rimovibile';

export const idControparteInTipoParte = '1';
export const idAltrePartiInTipoParte = '2';

export const tipiParteReatoOptions: TipoGenericoRimovibile[] = [
  {id: idControparteInTipoParte, label: 'Parte', descrizione: 'Parte', rimosso: false},
  {id: idAltrePartiInTipoParte, label: 'Altra parte', descrizione: 'Altra parte', rimosso: false},
];
